import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useTranslation } from 'react-i18next'
import Button from './Button'
import DialogHeader from '@/shared/DialogHeader'

const ConfirmCompanyDialog = ({
  title,
  children,
  message,
  onSubmit,
  onClose,
  cancelText,
  submitText,
  loading,
  contentProps,
  titleSx,
  actionsSx,
  dialogSx,
  ...props
}) => {
  const { t } = useTranslation()

  const handleClose = () => {
    onClose?.()
  }

  return (
    <Dialog
      {...props}
      maxWidth={'md'}
      PaperProps={{
        sx: {
          borderRadius: 5, // ← 圓角在這裡才有效
          overflow: 'hidden', //  必加，不然 Header 會蓋掉圓角
        },
      }}
      onClose={onClose}
    >
      {/* <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: theme => theme.palette.primary.main,
          mb: 2,
          ...titleSx,
        }}
      >
        {title}
        <IconButton
          edge="end"
          color="#979797"
          onClick={onClose}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: '24px',
            top: '12px',
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle> */}

      <DialogHeader
        title={t('general.delete_company_title')}
        onClose={handleClose}
      />

      <DialogContent {...contentProps} 
      sx={{
        mt: 3, mb: 2,
        '& *': {
          fontWeight: 700,
        },
        color: theme => `${theme.palette.primary.main}`
      }}>{children}</DialogContent>
      <DialogActions sx={{
        px: 3,
        pb: 2,
        justifyContent: 'flex-end', //  右下角
      }}>
        <Button style={{ minWidth: 100, backgroundColor: '#2D2D6C' }}
          loading={loading}
          disabled={loading}
          onClick={onSubmit}>
          {submitText || t('general.confirm_action')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmCompanyDialog
